module.exports = __webpack_public_path__ + "img/ppt.370380d5.svg";